import { styled } from "goober";
import { ExecutionGraph } from "./ExecutionGraph";
import { GhostedGraph } from "./GhostedWorkflowEmpty";

type Run = {
  id: string;
  createdAt: number;
  ephemeral: boolean | null;
};

type LatestRun = {
  createdAt: number;
  executions: ReadonlyArray<{
    status: "error" | "pending" | "success";
    duration: number | null;
  }>;
};

type Props = {
  runs: ReadonlyArray<Run>;
  latestRun: LatestRun | null;
  ghost: boolean;
  ghostSeed: string;
};

const Frame = styled("div")`
  flex: 1;
  min-height: 0;
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  overflow: hidden;
`;

export function WorkflowGraphPanel({
  runs,
  latestRun,
  ghost,
  ghostSeed,
}: Props) {
  return (
    <Frame>
      {ghost ? (
        <GhostedGraph seed={ghostSeed} />
      ) : (
        <ExecutionGraph runs={runs} latestRun={latestRun} />
      )}
    </Frame>
  );
}
